import { SendPhoneCode } from "../../../../components/SendPhoneCode";
import { Form, Input, message, Modal } from "antd";
import React, { FC, useState } from "react";
import { User } from "authing-js-sdk";
import { useTranslation } from "react-i18next";
import { Lang } from "@/locales";

export interface BindPhoneProps {
  visible: boolean;
  onOk?: (user: User) => void;
  onCancel?: () => void;
}

export const BindPhone: FC<BindPhoneProps> = ({ visible, onOk, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();

  return (
    <Modal
      title={t("common.bindPhone")}
      visible={visible}
      onOk={form.submit}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <Form
        form={form}
        hideRequiredMark
        labelAlign="left"
        labelCol={{ span: i18n.language === Lang.zhCn ? 4 : 6 }}
        onFinish={async (values) => {
          try {
            setLoading(true);
            const { phoneCode } = values;
            const user = await window.__authing__.updatePhone(phone, phoneCode);
            message.success(t("common.updateSuccess"));
            onOk && onOk(user);
          } finally {
            setLoading(false);
          }
        }}
      >
        <Form.Item
          name="phone"
          label={t("common.phoneNumber")}
          rules={[{ required: true, message: t("login.noEmpty") }]}
        >
          <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t("login.inputPhone")} />
        </Form.Item>

        <Form.Item
          name="phoneCode"
          label={t("common.verifyCode")}
          rules={[{ required: true, message: t("login.noEmpty") }]}
        >
          <Input
            autoComplete="one-time-code"
            placeholder={t("common.inputFourVerifyCode", {
              length: window.__config__.verifyCodeLength,
            })}
            addonAfter={<SendPhoneCode phone={phone} />}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
